var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "side-panel side-panel-left subnav active"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "side-panel-header top-sticky-blur top-sticky-blur-neutral d-none-pseudo px-0 pb-0 pt-4"
        },
        [
          _c("user-avatar", {
            attrs: {
              value: _vm.photoUrl,
              editable: "",
              scroll: _vm.scrollTop,
              size: "xl",
              variant: "default",
              url: "/settings/photo",
              name: "photo"
            },
            on: {
              upload: function($event) {
                return _vm.$store.dispatch("auth/fetchUser")
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "account-settings-meta" }, [
            _c(
              "h3",
              {
                staticClass: "txt-bold mt-2 mb-0 ph-no-capture",
                style: { fontSize: _vm.titleSize + "px" }
              },
              [_vm._v(_vm._s(_vm.user.name))]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "txt-body txt-muted ph-no-capture",
                style: { fontSize: _vm.emailSize + "px" }
              },
              [_vm._v(_vm._s(_vm.user.email))]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "txt-body txt-bold txt-muted",
                style: {
                  opacity: _vm.labelOpacity,
                  maxHeight: _vm.labelHeight + "px"
                }
              },
              [_vm._v(_vm._s(_vm.currentPlanLabel))]
            )
          ]),
          _vm._v(" "),
          _c("hr", {
            staticClass: "mb-0 mt-3",
            style: { opacity: 1 - _vm.labelOpacity }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "side-panel-body pb-4" },
        [
          _vm._l(_vm.childRoutes, function(group) {
            return [
              _c("h4", { staticClass: "txt-muted txt-body ml-1 p-2 mt-4" }, [
                _vm._v(_vm._s(group.title))
              ]),
              _vm._v(" "),
              _vm._l(group.routes, function(r, index) {
                return [
                  _c(
                    "div",
                    {
                      key: r.label + "-subnav",
                      attrs: { id: r.label + "-subnav-item" }
                    },
                    [
                      _c("router-link", {
                        class: { "disabled-link": r.locked },
                        attrs: {
                          to: r.locked ? {} : r.route ? { name: r.route } : {},
                          custom: !!r.onClick
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var navigate = ref.navigate
                                var isActive = ref.isActive
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "subnav-item",
                                      class: {
                                        "subnav-item-active":
                                          (isActive ||
                                            (r.route ===
                                              "AccountSubscription" &&
                                              _vm.$route.path.includes(
                                                "/settings/subscription"
                                              ))) &&
                                          !r.onClick &&
                                          !r.locked,
                                        "subnav-item-disabled": r.locked
                                      },
                                      attrs: {
                                        role: "link",
                                        "aria-disabled": r.locked,
                                        tabindex: r.locked ? -1 : 0
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          r.locked
                                            ? false
                                            : r.onClick
                                            ? r.onClick($event)
                                            : navigate($event)
                                        }
                                      }
                                    },
                                    [
                                      r.icon
                                        ? _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "icon-regular nav-icon",
                                              attrs: {
                                                width: "24",
                                                viewBox: "0 0 24 24"
                                              }
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "#icon-" + r.icon
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(r.label))
                                      ]),
                                      _vm._v(" "),
                                      r.locked
                                        ? [
                                            !(
                                              (r.route === "AccountWebhooks" &&
                                                _vm.$cant("webhooks")) ||
                                              (r.route === "AccountTeam" &&
                                                !_vm.hasTeams)
                                            )
                                              ? _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "icon-regular txt-muted ml-2",
                                                    attrs: {
                                                      width: "24",
                                                      viewBox: "0 0 24 24"
                                                    }
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xlink:href":
                                                          "#icon-lock"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            (r.route === "AccountWebhooks" &&
                                              _vm.$cant("webhooks")) ||
                                            (r.route === "AccountTeam" &&
                                              !_vm.hasTeams)
                                              ? _c("upgrade-button", {
                                                  staticClass: "ml-auto"
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      r.locked && !r.tooltipAction
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                "custom-class": "tooltip-no-wrap",
                                variant: "ss",
                                target: r.label + "-subnav-item",
                                triggers: "hover",
                                boundary: "viewport"
                              }
                            },
                            [
                              r.locked &&
                              r.route === "AccountTeam" &&
                              _vm.isMember
                                ? _c("span", [_vm._v(_vm._s(r.tooltip))])
                                : r.locked &&
                                  r.route !== "AccountWebhooks" &&
                                  r.route !== "AccountTeam"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        r.tooltip ? r.tooltip : "Coming soon"
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              })
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }